<template>
  <div>
    <loader class="imageLoader" :loading="loading" />
    <div class="tab__Item" v-if="items">
      <table class="postsTable">
        <thead>
          <tr>
            <th>User</th>
            <th>Admin</th>
          </tr>
        </thead>
        <tbody v-if="loading === false">
          <user :showAdmin="true" v-for="(item, index) in items" :item="item" :index="index" :key="item.id"></user>
        </tbody>
      </table>

      <div class="error" v-if="items && items.length === 0">
        <p>There are currently no active users.</p>
      </div>
    </div>

    <transition name="fade">
      <router-view v-if="loading === false"></router-view>
    </transition>

    <nav class="modal__Add--User" v-if="$route.params.id">
      <router-link class="modal__AddIcon--User" append to="user/add">
        <icon name="user-plus" weight="regular"></icon>
      </router-link>
    </nav>
  </div>
</template>

<script>
import User from '@/components/listing/User.vue'
import Loader from '@/components/partials/Loader.vue'

export default {
  name: 'Users',
  props: ['orgID', 'search'],
  components: {
    User,
    Loader,
  },
  data() {
    return {
      loading: true,
    }
  },
  computed: {
    items() {
      if (this.search.length > 0)
        return this.$store.state.accounts.users.active.filter((user) =>
          user.name.toLowerCase().includes(this.search.toLowerCase())
        )
      return this.$store.state.accounts.users.active
    },
  },
  mounted() {
    const orgID = this.orgID
    this.$store.dispatch('getUsers', { status: 'active', orgID }).then(
      () => {
        this.loading = false
      },
      (error) => {
        console.error(error)
      }
    )
  },
}
</script>
